import { render, staticRenderFns } from "./configuration-automation-assays-modal.vue?vue&type=template&id=0af2e8cf&scoped=true&"
import script from "./configuration-automation-assays-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-assays-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-automation-assays-modal.scss?vue&type=style&index=0&id=0af2e8cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af2e8cf",
  null
  
)

export default component.exports